import { defineStore } from 'pinia'

import type { DisciplineCommentsStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'

export const useDisciplineCommentsStore = defineStore('discipline-comments', {
  state: (): DisciplineCommentsStore => ({
    loading: false,
    comments: [],
    nextCursor: null,
  }),
  actions,
  getters,
})
